<template>
    <el-container>
        <el-header class="top-title" style="height:60px!important;">
            <!-- 平台logo -->
            <div class="top_left">
                <div class="top_title_center_logo">
                    <!-- <img style="vertical-align: middle;" :src="imgUrl" /> -->
                </div>
            </div>
            <!-- 平台名称 -->
            <div class="top_car">
                <span class="top_title_center">{{ systemName }}</span>
            </div>
            <!-- 一级菜单 -->
            <div class="top_menu">
                <h-topMenu ref="topMenu" :getDivLeft="getDivLeft" :menuData="this.menuData" :pushLeftMenu="pushLeftMenu" :topIndexId="this.topIndexId"></h-topMenu>
            </div>
            <!-- 自定义图标 -->
            <div id="constom" :class="otherCustomMenuList.length > 0 ? 'constomClass' : 'constomClass_other'">
                <div
                    :style="'height:25px;width:25px;margin-right:5px;display:inline-block;cursor:pointer;background:url(' + custom.prefixUrl + skin + custom.imageUrl + ')'"
                    @click="eventClick(custom.event)"
                    :key="index"
                    v-for="(custom, index) in customMenuList"
                ></div>
            </div>
            <!-- 更多图标 -->
            <div class="moreConstomClass">
                <el-dropdown @command="eventClick" v-show="otherCustomMenuList.length > 0">
                    <span class="el-dropdown-link">
                        <img :src="'skin/' + skin + '/img/topImage/more.png'" />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :key="index" v-for="(otherCustom, index) in otherCustomMenuList" :command="otherCustom.event">
                            <img :src="otherCustom.prefixUrl + skin + otherCustom.imageUrl" />
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="top_userImg" v-show="userImgShow">
                <img ondragstart="return false;" src="@/assets/images/admin_new.png" class="top-img-admin" />
            </div>
            <el-dropdown class="top_user" @command="command" v-show="userShow">
                <span class="el-dropdown-link">
                    <span class="top_username">{{ username }}<span class="el-icon-caret-bottom"></span></span>
                </span>
                <td-permission :permissions="permissionsView">
                    <div slot="havePermission">
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="usercener">{{ $t('navbar.USER_CENTER') }}</el-dropdown-item>
                            <el-dropdown-item command="about">{{ $t('navbar.ABOUT') }}</el-dropdown-item>
                            <el-dropdown-item :command="onlineUsers">{{ $t('navbar.USER_ONLINE') }}</el-dropdown-item>
                            <el-dropdown-item command="logout">{{ $t('navbar.Logout') }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </div>
                </td-permission>
                <td-permission :permissions="permissionsView">
                    <div slot="noPermission">
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item :command="usercener">{{ $t('navbar.USER_CENTER') }}</el-dropdown-item>
                            <el-dropdown-item command="about">{{ $t('navbar.ABOUT') }}</el-dropdown-item>
                            <el-dropdown-item command="logout">{{ $t('navbar.Logout') }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </div>
                </td-permission>
            </el-dropdown>
            <h-language></h-language>
            <h-colorchange></h-colorchange>
            <dialog-Pwd v-if="dialogPwdVisible" :dialogPwdVisible="dialogPwdVisible" :editItem="editItem" :title="title" ref="ModifyInfo" @cancelPass="cancelPass"></dialog-Pwd>
        </el-header>
    </el-container>
</template>
<script>
import topMenu from './topMenu.vue';
import colorchange from './colorchange.vue';
import language from './language.vue';
import dialogPwd from './dialogModifyPwd.vue';
let logoImg = {
    type: String,
    default: 'Logo.png'
};
export default {
    components: {
        'h-topMenu': topMenu,
        'h-colorchange': colorchange,
        'h-language': language,
        'dialog-Pwd': dialogPwd
    },
    computed: {
        systemName: function() {
            return window.app.homePageTitle;
        },
        imgUrl: function() {
            let url =
                (window.app.sPlatformFlg === window.vue.$common.systemName.NETVIDEO ? './plugins/TdPluginEasy7Main/web/oem/' : './plugins/TdPluginEasy7Main/web/') +
                window.vue.$store.state.skin +
                '/img/' +
                logoImg.default;
            if (!window.vue.$util.isEmpty(window.app.loginImgPathKey)) {
                url = window.location.protocol + '//' + window.location.host + '//' + window.app.loginImgPathKey.split('//')[1];
            }
            return url;
        }
    },
    props: {
        username: String,
        topIndexId: String,
        menuData: Array,
        pushLeftMenu: {
            type: Function,
            default: null
        }
    },
    data() {
        return {
            permissionsView: ['sys:online'],
            roles: ['admin'],
            isvisible: false,
            dialogAboutVisible: false,
            skin: window.vue.$store.state.skin,
            editItem: {
                oldPass: '',
                newPass: '',
                confirmPass: ''
            },
            seen: false,
            dialogPwdVisible: false,
            title: '',
            timeOut: '',
            height: '',
            usercener: 'usercener',
            onlineUsers: 'onlineUsers',
            userImgShow: true,
            userShow: true,
            customMenuList: [],
            otherCustomMenuList: [],
            customMenuNum: 0,
            topLogoImageClass: window.vue.$store.state.topLogoImageClass
        };
    },
    mounted() {
        //无用户隐藏图标
        if (sessionStorage !== null && sessionStorage.getItem('username') === null) {
            this.userShow = false;
            this.userImgShow = false;
        } else {
            this.userShow = true;
            this.userImgShow = true;
        }
        /* 浏览器关闭调用登录接口 */
        window.onbeforeunload = () => {
            // this.logout();
        };
        //初始化自定义图标
        this.initTopMenuNum();
    },
    methods: {
        initTopMenuNum() {
            let param = {
                sTag: this.$common.topImageMangerFlag + window.app.sPlatformFlg
            };
            this.$api.getDictValuesByType(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    if (response.data && response.data.statusMessage) {
                        this.$message({
                            showClose: true,
                            message: response.data.statusMessage,
                            type: 'error'
                        });
                    }
                    this.$log.error('top/getDictValuesByType', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('top/getDictValuesByType', response.data.message);
                    return;
                }
                if (response.data.content.length > 0) {
                    this.customMenuNum = response.data.content[0].sCode;
                }
                this.initCustomTopMenu();
            });
        },
        initCustomTopMenu() {
            let param = {
                sTag: this.$common.topImageFlag + window.app.sPlatformFlg
            };
            this.$api.getDictValuesByType(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    if (response.data && response.data.statusMessage) {
                        this.$message({
                            showClose: true,
                            message: response.data.statusMessage,
                            type: 'error'
                        });
                    }
                    this.$log.error('top/getDictValuesByType', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('top/getDictValuesByType', response.data.message);
                    return;
                }
                response.data.content.forEach((costom, index) => {
                    if (index < this.customMenuNum) {
                        this.customMenuList.push(JSON.parse(costom.sCode));
                    } else {
                        this.otherCustomMenuList.push(JSON.parse(costom.sCode));
                    }
                });
                this.$nextTick(function() {
                    this.$refs.topMenu.dealMenuInfo();
                });
                this.$EventBus.$emit('initCustomTopMenuEvent');
            });
        },
        command(val) {
            if (val === this.usercener) {
                this.usernameclick();
            } else if (val === this.onlineUsers) {
                this.onlineUsersClick();
            } else if (val === 'about') {
                // window.vue.$EventBus.$emit('eventMouduleAbout');
                this.aboutclick();
            } else {
                this.logout();
            }
        },
        aboutclick() {
            this.$confirm(window.config.about, '关于', {
                showConfirmButton: false,
                showCancelButton: false,
                dangerouslyUseHTMLString: true
            });
        },
        colsedlalog() {
            this.isvisible = false;
        },
        username_mouseenter() {
            this.seen = true;
        },
        username_mouseleave() {
            this.timeOut = setTimeout(() => {
                this.seen = false;
            }, 100);
        },
        usernameclick() {
            this.$router.push('/userCenter/userCenter');
        },
        onlineUsersClick() {
            this.$router.push('/onlineUsers/onlineUsers');
        },
        menu_mouseenter() {
            clearTimeout(this.timeOut);
            this.seen = true;
        },
        menu_mouseleave() {
            this.seen = false;
        },
        changePassword() {
            this.dialogPwdVisible = true;
        },
        cancelPass() {
            this.dialogPwdVisible = false;
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        getDivLeft(id) {
            return window.$(id).offset().left;
        },
        logout() {
            this.$confirm(this.$t('common.CONFIRM_EXIT'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    this.$store.commit('RESET_STATE');
                    let _this = this;
                    this.$api.logout('', response => {
                        _this.$router.push('/');
                        this.$EventBus.$emit('mainLogoutEvent');
                        window.vue.$dataBusUtil.disconnectMq();
                    });
                })
                .catch(() => {});
        },
        eventClick(info) {
            this.$EventBus.$emit(info);
        }
    }
};
</script>
<style scoped>
.constomClass {
    line-height: 60px;
    position: absolute;
    right: 0;
    top: 7px;
    float: right;
    font-size: 15px;
    padding-right: 165px;
}
.constomClass_other {
    line-height: 60px;
    position: absolute;
    right: 0;
    top: 7px;
    float: right;
    font-size: 15px;
    padding-right: 135px;
}
.moreConstomClass {
    width: 100px;
    position: absolute;
    right: 0;
    top: 17px;
    float: right;
    font-size: 18px;
    padding-right: 60px;
}
.top_title_center_logo {
    float: left;
    height: 60px;
    line-height: 60px;
}
</style>
